/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Border_OffInputs */

const fr_label_border_off = /** @type {(inputs: Label_Border_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désactivées`)
};

const en_label_border_off = /** @type {(inputs: Label_Border_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabled`)
};

/**
* | output |
* | --- |
* | "Disabled" |
*
* @param {Label_Border_OffInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_border_off = /** @type {((inputs?: Label_Border_OffInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Border_OffInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_border_off(inputs)
	return en_label_border_off(inputs)
});